"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SORT_CATEGORIES_BY = exports.CATEGORIES_OF_PRODUCT_FIELDS_TO_FETCH_IN_CREATION_OF_PRODUCT = exports.BASE_API_URL = void 0;

var _Utils = require("react-platform-components/dist/Utils");

var BASE_API_URL = (0, _Utils.getBackendConfig)('REACT_BASE_API_URL', process.env.REACT_APP_BASE_API_URL);
exports.BASE_API_URL = BASE_API_URL;
var CATEGORIES_OF_PRODUCT_FIELDS_TO_FETCH_IN_CREATION_OF_PRODUCT = JSON.parse(process.env.REACT_APP_CATEGORIES_OF_PRODUCT_FIELDS_TO_FETCH_IN_CREATION_OF_PRODUCT || '["deep_category_specificities", "id", "is_final", "name", "parent_category_id"]');
exports.CATEGORIES_OF_PRODUCT_FIELDS_TO_FETCH_IN_CREATION_OF_PRODUCT = CATEGORIES_OF_PRODUCT_FIELDS_TO_FETCH_IN_CREATION_OF_PRODUCT;
var SORT_CATEGORIES_BY = process.env.REACT_APP_SORT_CATEGORIES_BY || "created_at";
exports.SORT_CATEGORIES_BY = SORT_CATEGORIES_BY;